import BaseModal, { BaseModalContent } from '$elements/BaseModal'
import usePhoneVerification from '$layouts/AuthenticatedLayout/context/usePhoneVerification'
import { FC } from 'react'
import { backButton, content } from './styles.css'
import { Icon } from '@trustycars/genie-ui/icons'
import OTPBlock from '$blocks/OTPBlock'

type VerifyPhoneBlockProps = Omit<
  ReturnType<typeof usePhoneVerification>,
  'request'
>

export const VerifyPhoneBlock: FC<VerifyPhoneBlockProps> = props => (
  <BaseModal {...props.modal}>
    <BaseModalContent className={content}>
      <button
        type="button"
        onClick={props.cancel}
        className={backButton}
        disabled={props.loading}
      >
        <Icon namespace="Backward" /> Back
      </button>

      <OTPBlock {...props.otpBlock} />
    </BaseModalContent>
  </BaseModal>
)

export default VerifyPhoneBlock
